/**
 * Export CSV de hallazgos (F1). Pura y sin DOM: la capa web decide cómo
 * descargar el blob; aquí solo se construye el contenido.
 */

import type { FindingWithMeta } from "./queries";

/** Escapa un campo CSV (RFC 4180: comillas dobles + envoltura condicional). */
export function csvField(value: string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return "";
  }
  const str = String(value);
  if (/[",\n\r;]/u.test(str)) {
    return `"${str.replaceAll('"', '""')}"`;
  }
  return str;
}

export interface FindingsCsvLabels {
  title: string;
  description: string;
  severity: string;
  status: string;
  site: string;
  assignee: string;
  dueDate: string;
  createdAt: string;
  closedAt: string;
}

/** Construye el CSV (con cabecera localizada) de un listado de hallazgos. */
export function buildFindingsCsv(
  findings: readonly FindingWithMeta[],
  labels: FindingsCsvLabels,
): string {
  const header = [
    labels.title,
    labels.description,
    labels.severity,
    labels.status,
    labels.site,
    labels.assignee,
    labels.dueDate,
    labels.createdAt,
    labels.closedAt,
  ]
    .map(csvField)
    .join(",");

  const rows = findings.map((f) =>
    [
      f.title,
      f.description,
      f.severity,
      f.status,
      f.site_name,
      f.assignee_name,
      f.due_date,
      f.created_at,
      f.closed_at,
    ]
      .map(csvField)
      .join(","),
  );

  return [header, ...rows].join("\r\n");
}
